<canvas #snakeCanvas width="640" height="480" style="border: 1px solid black"></canvas>